import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_3 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_4 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }

import DataTable from '@/components/DataTable.vue';
import PagePagination from '@/components/PagePagination.vue'

import { ref, onMounted } from 'vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import BookingService from '@/classes/BookingService';

import { useRoute } from 'vue-router';
import { onIonViewWillEnter } from '@ionic/vue';
import { formatDate, formatTime  } from '@/helpers/TimeFormatter'



export default /*@__PURE__*/_defineComponent({
  __name: 'ScheduleLogs',
  props: {
    bookingId: {
        type: String,
        default: null
    }
},
  setup(__props) {

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref(null)
const errors      = ref([])

const props = __props;

const route = useRoute();

const booking_type = ref(route.query.booking_type ?? route.query.patient_type);
const items = ref([]);

const fetchScheduleLogs = () => {
    loader.value = true

    BookingService.fetchScheduleLogs(booking_type.value, props.bookingId)
        .then((result: any) => {
            loader.value = false;
            
            if(result.data.result_status == 200 && result.data.message == 'Success') {
                items.value = result.data.response;
            } else if(result.data.response.result_status == 500) {
                showError.value = true;
                errorMsg.value  = "Something went wrong. Please try again later";
            }

        })
        .catch((error) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error;

            if(error.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const formatRescheduledDateText = (scheduleLog: any) => {
    let textDisplay = "N/A";
    
    if(scheduleLog.new_booking_start_time && scheduleLog.new_booking_end_time) {
        textDisplay = `This appointment has been rescheduled to ${formatDate(scheduleLog.new_booking_date)} at ${formatTime(scheduleLog.new_booking_start_time)} - ${formatTime(scheduleLog.new_booking_end_time)} by the Admin.`;
    } else if (scheduleLog.new_booking_date) {
        textDisplay = `This appointment has been rescheduled to ${formatDate(scheduleLog.new_booking_date)} by the Admin.`;
    } else if (scheduleLog.original_booking_date) {
        textDisplay = `Initial appointment was made on ${formatDate(scheduleLog.original_booking_date)} at ${formatTime(scheduleLog.original_booking_start_time)} - ${formatTime(scheduleLog.original_booking_end_time)} by the patient.`;
    }

    return textDisplay;
}

// Headers
const headers: { text: string }[] = [
    { text: 'ID' },
    { text: 'Description' },
    { text: 'Reason' },
];

onMounted(() => {
    loader.value = true;
    fetchScheduleLogs()
})

onIonViewWillEnter(() => {
    loader.value = true;
    fetchScheduleLogs();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(DataTable, {
        headers: headers,
        count: items.value.length,
        "no-action": ""
      }, {
        body: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_2, _toDisplayString(index + 1), 1),
              _createElementVNode("td", _hoisted_3, _toDisplayString(formatRescheduledDateText(item)), 1),
              _createElementVNode("td", _hoisted_4, _toDisplayString(item.description), 1)
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["count"])
    ]),
    _createVNode(PagePagination, {
      class: "mb-6",
      items: items.value,
      onNextPage: fetchScheduleLogs
    }, null, 8, ["items"]),
    (loader.value)
      ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(ErrorModal, {
      width: "w-[548px]",
      title: "Error",
      "action-text": "Close",
      "cancel-text": "Go back",
      show: showError.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (showError.value = false)),
      onConfirm: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false)),
      errors: errors.value
    }, {
      content: _withCtx(() => [
        _createTextVNode(_toDisplayString(errorMsg.value), 1)
      ]),
      _: 1
    }, 8, ["show", "errors"])
  ], 64))
}
}

})